import React from 'react';
import { Grid, Box, useTheme, useMediaQuery } from '@material-ui/core';
import { Container, Image } from 'components';
import { Link } from 'react-router-dom';
import { imageHeart, imageUsa, imagePiggy } from './images';

import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

import './styles.sass';

function InfoSection(): React.ReactElement {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <div className="home-info-section">
      <Container>
        <Grid container justify="center" className="home-info-section-item">
          <Grid item xs={12} sm={4}>
            <Box width={isMobile ? 1 / 3 : 3 / 5} className="info-item-img">
              <Image
                src={imagePiggy}
                alt="We stay small so that you save big."
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <h2 className="info-item-title">We stay small <br className="text-mobile-width-breakpoint" /> so you save big.</h2>
            <p className="info-item-description">We aim to be the most affordable mobile carrier out there, so we don’t spend a lot on marketing to help keep your wireless bill small.</p>
          </Grid>
        </Grid>
        <Grid container justify="center" className="home-info-section-item">
          <Grid item xs={12} sm={4}>
            <Box width={isMobile ? 1 / 2 : 3 / 5} className="info-item-img">
              <Image src={imageUsa} alt="Big carrier coverage." />
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <h2 className="info-item-title">Big carrier coverage.</h2>
            <p className="info-item-description">You’re covered throughout Hawaiʻi and we partner with bigger carriers to bring you better nationwide coverage with reliable voice, text, and fast speeds just about everywhere you explore.</p>
          </Grid>
        </Grid>
        <Grid container justify="center" className="home-info-section-item">
          <Grid item xs={12} sm={4}>
            <Box width={isMobile ? 1 / 3 : 4 / 7} className="info-item-img">
              <Image src={imageHeart} alt="Customer service is at the heart of who we are." />
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <h2 className="info-item-title">Care means everything to us.</h2>
            <p className="info-item-description">The Mobi Care team is here to answer any questions you have along the way — just give us a call, send us a text, or email us for help.</p>
            <Link to="about">
              <p className="info-item-link flex-row">Meet our team <ArrowRightAltIcon /></p>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default InfoSection;
